import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { InView } from '../InView';
import { PhoneSnak } from '../PhoneSnak';
import { FloatingHearts } from '../FloatingHearts';
import { FerringWordmark } from '../../FerringWordmark';
import { PresentationLogo } from '../../PresentationLogo';
import { ConceptModal } from '../../concept/ConceptModal';
import { snakTraits } from '../../../data/deck';
const WORDS = ['Short.', 'Sharp.', 'Satisfying.'];
export function OpeningSection() {
  const [conceptOpen, setConceptOpen] = useState(false);
  return <section id="opening" aria-label="All you need is love" className="relative flex min-h-screen w-full flex-col overflow-hidden bg-[var(--surface)]" data-id="element-538" data-mp="26r5y69cvnhhv">
      <FloatingHearts data-id="element-539" data-mp="2fs42ksr89r0z" />

      <div className="relative flex items-center justify-between gap-4 px-8 pt-6 lg:px-14" data-id="element-540" data-mp="2frubt2yczfu8">
        <div className="flex items-center gap-4" data-id="element-541" data-mp="1s204t20q0lhw">
          <FerringWordmark data-id="element-542" data-mp="1o1g63u0i19tn" />
          <span className="h-6 w-px bg-[var(--fg)]/15" aria-hidden="true" data-id="element-543" data-mp="1o293i4dkimz4" />
          <span className="text-[10px] font-semibold uppercase tracking-[0.24em] text-[var(--fg)]/45" data-id="element-544" data-mp="3q8bja3acqy00">
            REKOVELLE · Follow-up
          </span>
        </div>
        <PresentationLogo data-id="element-545" data-mp="3u22af8r4s99" />
      </div>

      <main className="relative flex flex-1 items-center" data-id="element-546" data-mp="3v3ambydv0na">
        <div className="mx-auto grid w-full max-w-[1440px] items-center gap-14 px-8 py-12 lg:grid-cols-[minmax(0,1fr)_auto] lg:gap-20 lg:px-14 lg:py-8" data-id="element-547" data-mp="8slkc4k85jwc">
          <div className="max-w-[620px]" data-id="element-548" data-mp="37cbrotladwgy">
            <InView data-id="element-549" data-mp="3c9bvsyyksp5f">
              <h1 className="text-[58px] font-extrabold leading-[0.92] tracking-[-0.055em] text-[var(--fg)] sm:text-[84px]" data-id="element-550" data-mp="3can1537o64yn">
                All you need is love.
              </h1>
            </InView>
            <InView delay={0.1} data-id="element-551" data-mp="3m8t0pe606z0c">
              <p className="mt-7 flex flex-wrap items-center gap-x-4 gap-y-1" data-id="element-552" data-mp="3m92qb0n4z45i">
                {WORDS.map((word, i) => <span key={word} className="flex items-center gap-4" data-id="element-553" data-mp="11hitni6gk6cy" data-mpi={i}>
                    {i > 0 && <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-[var(--brand)]/40" data-id="element-554" data-mp="11jn64oifadou" />}
                    <span className="text-[22px] font-extrabold tracking-[-0.03em] text-[var(--brand)]" data-id="element-555" data-mp="2xmi7kgkhmmt6">{word}</span>
                  </span>)}
              </p>
            </InView>

            <InView delay={0.2} className="mt-10" data-id="element-556" data-mp="36j0xrl1c3wm2">
              <div className="rounded-2xl bg-white p-5 ring-1 ring-[var(--fg)]/5" data-id="element-557" data-mp="32kthssep2zbx">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-558" data-mp="2ete98hwbrls8">A Snak, in one line</p>
                <p className="mt-1.5 text-[16px] font-bold leading-snug text-[var(--fg)]" data-id="element-559" data-mp="29we181fx08yh">
                  A short, interactive story HCPs take part in — turning important content into something they notice,
                  understand and act on.
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-3" data-id="element-560" data-mp="1v5omip38wbpv">
                  {snakTraits.map(trait => <li key={trait.title} className="rounded-xl bg-[var(--surface)] px-3 py-2" data-id="element-561" data-mp="1r3jxy4rnm5a3">
                      <span className="block text-[12px] font-extrabold uppercase tracking-[0.14em] text-[var(--brand)]" data-id="element-562" data-mp="1h0eozk2x2c1m">
                        {trait.title}
                      </span>
                      <span className="block text-[12px] leading-snug text-[var(--muted)]" data-id="element-563" data-mp="1730fk4feunit">{trait.body}</span>
                    </li>)}
                </ul>
              </div>
            </InView>

            <InView delay={0.28} className="mt-8 flex flex-wrap items-center gap-3" data-id="element-564" data-mp="1zs7h7ca5vt8a">
              <button type="button" onClick={() => document.getElementById('congress')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })} className="inline-flex items-center gap-2 rounded-full bg-[var(--brand)] px-6 py-3.5 text-[14px] font-bold text-white shadow-sm transition-[background-color,transform] duration-150 hover:bg-[var(--fg)] active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)] focus-visible:ring-offset-2" data-id="element-565" data-mp="24qipvjopzxox">
                See the ESHRE 2027 idea
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-566" data-mp="utc7bz4dbtac" />
              </button>
            </InView>
          </div>

          <InView delay={0.16} y={26} className="flex justify-center lg:justify-end" data-id="element-567" data-mp="ptfynmkq7dog">
            <div className="flex flex-col items-center gap-5" data-id="element-568" data-mp="kvo8oy3n61mw">
              <span className="text-[10px] font-semibold uppercase tracking-[0.24em] text-[var(--fg)]/40" data-id="element-569" data-mp="ktbixyrn6mza">
                Example Snak · REKOVELLE
              </span>
              <PhoneSnak label="Live REKOVELLE teaser Snak" onConcept={() => setConceptOpen(true)} className="h-[clamp(560px,calc(100vh-240px),800px)]" data-id="element-570" data-mp="1dkd3kfe3taq7" />
              <span className="text-[11px] font-medium tracking-[0.02em] text-[var(--muted)]" data-id="element-571" data-mp="13le15ejxmbbn">
                Tap to play · about 40 seconds
              </span>
            </div>
          </InView>
        </div>
      </main>

      <footer className="relative px-8 pb-6 lg:px-14" data-id="element-572" data-mp="23tuckgr3phqp">
        <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-[var(--fg)]/30" data-id="element-573" data-mp="23vf6c45lcwni">
          Concept &amp; creative direction © Snakker™ 2026 · Subject to Ferring medical/legal review
        </p>
      </footer>

      <ConceptModal open={conceptOpen} onClose={() => setConceptOpen(false)} data-id="element-574" data-mp="2dpxd5i6b18bj" />
    </section>;
}